import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import CONFIG from 'Config/settings';
import './style.scss';

export const Row = props => {
  const prefix = CONFIG.APP.STYLES_PREFIX;
  return (
    <div
      className={classNames(`${prefix}ikea-row`, {
        [`${prefix}ikea-row-center`]: props.center,
        [props.className]: props.className
      })}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

Row.propTypes = {
  className: PropTypes.string,
  center: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};
